import { axiosJwt } from '@/shared/auth/axios-lib'
import axios from 'axios'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    solicitarAcesso(solicitacaoAcesso) {
        return axios
            .post(
                `${api}/controleacesso/solicitacoesacesso/${solicitacaoAcesso.tipoAcesso == 1 ? 'pj' : 'pf'
                }`,
                solicitacaoAcesso
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTodas(status) {
        return axiosJwt
            .get(
                `${api}/controleacesso/solicitacoesacesso?status=${status != -1 ? status : ''
                }`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt
            .get(`${api}/controleacesso/solicitacoesacesso/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovar(solicitacaoAcesso) {
        return axiosJwt
            .post(
                `${api}/controleacesso/solicitacoesacesso/${solicitacaoAcesso.solicitacaoAcessoId}/reprovar`,
                solicitacaoAcesso
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovar(solicitacaoAcessoId) {
        return axiosJwt
            .post(
                `${api}/controleacesso/solicitacoesacesso/${solicitacaoAcessoId}/aprovar`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
